"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FormField;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _uiIcons = require("@blueprism/ui-icons");

var _Stack = _interopRequireDefault(require("../../layout/Stack"));

var _Row = _interopRequireDefault(require("../../layout/Row"));

var _Box = _interopRequireDefault(require("../../layout/Box"));

var _utils = require("../../utils/utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FieldContainer = (0, _styledComponents["default"])(_Stack["default"]).withConfig({
  displayName: "FormField__FieldContainer",
  componentId: "l10ye8-0"
})(["border:0;"]);
var FieldLabel = (0, _styledComponents["default"])(_Row["default"]).withConfig({
  displayName: "FormField__FieldLabel",
  componentId: "l10ye8-1"
})(function (_ref) {
  var theme = _ref.theme,
      error = _ref.error,
      standalone = _ref.standalone;
  return (0, _styledComponents.css)(["color:", ";font-weight:", ";background-color:", ";border-radius:0.125rem;", ""], error ? theme.color.paper : theme.color.text, theme.font.weight.bold, error ? theme.color.warning : 'none', standalone && (0, _styledComponents.css)(["font-size:", "rem;font-weight:", ";line-height:1.75rem;"], theme.font.size.bodyL, !error ? theme.font.weight.regular : theme.font.weight.bold));
});
var IconContainer = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "FormField__IconContainer",
  componentId: "l10ye8-2"
})(function (_ref2) {
  var theme = _ref2.theme,
      error = _ref2.error;
  return (0, _styledComponents.css)(["display:flex;align-items:center;background-color:", ";width:", ";min-width:", ";padding-top:0.25rem;svg{margin-left:auto;margin-right:auto;}"], error ? theme.color.warning : 'none', theme.globalSizes.large, theme.globalSizes.large);
});
var ControlContainer = (0, _styledComponents["default"])(_Stack["default"]).withConfig({
  displayName: "FormField__ControlContainer",
  componentId: "l10ye8-3"
})(["padding-left:", ";"], function (props) {
  return props.theme.globalSizes.large;
});

var HelperSpan = _styledComponents["default"].span.withConfig({
  displayName: "FormField__HelperSpan",
  componentId: "l10ye8-4"
})(function (_ref3) {
  var theme = _ref3.theme,
      standalone = _ref3.standalone;
  return (0, _styledComponents.css)(["color:", ";font-size:", "rem;", ""], theme.color.text, theme.font.size.caption, standalone && (0, _styledComponents.css)(["font-size:", "rem;"], theme.font.size.body));
});

var HelperList = _styledComponents["default"].ul.withConfig({
  displayName: "FormField__HelperList",
  componentId: "l10ye8-5"
})(["list-style:none;margin:0;padding:0;"]);

function HelperText(_ref4) {
  var id = _ref4.id,
      error = _ref4.error,
      errorText = _ref4.errorText,
      isFieldset = _ref4.isFieldset,
      standalone = _ref4.standalone,
      helperText = _ref4.helperText;

  if (!error) {
    return /*#__PURE__*/_react["default"].createElement(HelperSpan, {
      id: id,
      standalone: isFieldset && standalone
    }, helperText);
  }

  if (typeof errorText === 'string') {
    return /*#__PURE__*/_react["default"].createElement(HelperSpan, {
      id: id,
      standalone: isFieldset && standalone
    }, errorText);
  }

  if (Array.isArray(errorText)) {
    return /*#__PURE__*/_react["default"].createElement(HelperList, {
      id: id
    }, errorText.filter(function (message) {
      return message;
    }).map(function (message) {
      return /*#__PURE__*/_react["default"].createElement(HelperSpan, {
        as: "li",
        key: message,
        standalone: isFieldset && standalone
      }, message);
    }));
  }

  return null;
}
/**
 * #### Form control container component
 *
 * The `FormField` component is used to provide a consistent container for form controls. It provides labeling information and validation context for its children. The component will either display the `helperText` or `errorText` depending on whether the `error` prop is set to `true`. This `error` prop is also forwarded down to children to ensure consistency.
 *
 * By default, the `FormField` is intended to be used with single form controls and as such will render a `<div>` and a `<label>`. However, a combination of form components can be passed in as its children. In this case, the `isFieldset` prop should be set to `true` so that the component renders a `<fieldset>` and `<legend>` instead to ensure the HTML is semantically correct.
 */


function FormField(_ref5) {
  var _clonePropsToChildren;

  var children = _ref5.children,
      label = _ref5.label,
      _ref5$htmlFor = _ref5.htmlFor,
      htmlFor = _ref5$htmlFor === void 0 ? '' : _ref5$htmlFor,
      icon = _ref5.icon,
      _ref5$helperText = _ref5.helperText,
      helperText = _ref5$helperText === void 0 ? '' : _ref5$helperText,
      _ref5$errorText = _ref5.errorText,
      errorText = _ref5$errorText === void 0 ? '' : _ref5$errorText,
      _ref5$error = _ref5.error,
      error = _ref5$error === void 0 ? false : _ref5$error,
      _ref5$standalone = _ref5.standalone,
      standalone = _ref5$standalone === void 0 ? false : _ref5$standalone,
      _ref5$isFieldset = _ref5.isFieldset,
      isFieldset = _ref5$isFieldset === void 0 ? false : _ref5$isFieldset,
      _ref5$gap = _ref5.gap,
      gap = _ref5$gap === void 0 ? 'base' : _ref5$gap,
      rest = _objectWithoutProperties(_ref5, ["children", "label", "htmlFor", "icon", "helperText", "errorText", "error", "standalone", "isFieldset", "gap"]);

  var _React$useContext = _react["default"].useContext(_styledComponents.ThemeContext),
      color = _React$useContext.color;

  return /*#__PURE__*/_react["default"].createElement(FieldContainer, _extends({
    element: isFieldset ? 'fieldset' : 'div',
    padding: "none",
    gap: gap
  }, rest), /*#__PURE__*/_react["default"].createElement(FieldLabel, {
    error: error,
    standalone: isFieldset && standalone,
    align: "start",
    gap: "none",
    padding: "none"
  }, /*#__PURE__*/_react["default"].createElement(IconContainer, {
    padding: "none"
  }, error && ((_clonePropsToChildren = (0, _utils.clonePropsToChildren)(icon, {
    size: 16,
    color: color.paper
  })) !== null && _clonePropsToChildren !== void 0 ? _clonePropsToChildren : /*#__PURE__*/_react["default"].createElement(_uiIcons.Alert, {
    size: 16,
    color: color.paper
  }))), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    element: isFieldset ? 'legend' : 'label',
    padding: "none",
    htmlFor: htmlFor
  }, label)), /*#__PURE__*/_react["default"].createElement(ControlContainer, {
    padding: "none",
    gap: gap
  }, /*#__PURE__*/_react["default"].createElement(HelperText, {
    id: "helper-text-".concat(htmlFor),
    error: error,
    errorText: errorText,
    isFieldset: isFieldset,
    standalone: standalone,
    helperText: helperText
  }), (0, _utils.clonePropsToChildren)(children, _defineProperty({
    error: error
  }, 'aria-describedby', helperText && "helper-text-".concat(htmlFor)))));
}